"use strict";
import DataStoreService from "./data_store_service";
import LoadsService from "./loads_service";
import {
  AddDocumentToLoadUploadStatus
} from "./data/types/Pb";
const AddDocumentToLoadUpdateHandlerService = function() {
  this.maybeLoadStateId = null;
  this.startService = (maybeLoadStateId) => {
    this.maybeLoadStateId = maybeLoadStateId;
    $(DataStoreService).on(
      "DataStoreService:addDocumentToLoad",
      { maybeLoadStateId: this.maybeLoadStateId },
      this.handleAddDocumentToLoad
    );
  };
  this.stopService = () => {
    $(DataStoreService).off("DataStoreService:addDocumentToLoad", this.handleAddDocumentToLoad);
  };
  this.handleAddDocumentToLoad = (event, data) => {
    if (data.loadStateId === event.data.maybeLoadStateId) {
      this.notifyAndRefreshLoad(data.uploadStatus, data.fileCount);
    }
  };
  this.notifyAndRefreshLoad = (uploadStatus, fileCount) => {
    switch (uploadStatus) {
      case AddDocumentToLoadUploadStatus.AddDocumentToLoadUploadStatusSuccess:
        LoadsService.forceGetLoad(this.maybeLoadStateId);
        this.notifySuccess(fileCount);
        break;
      case AddDocumentToLoadUploadStatus.AddDocumentToLoadUploadStatusFailed:
        this.notifyFailure();
        break;
      default:
        console.error("Unknown upload status:", uploadStatus);
    }
  };
  this.notifyInProgress = () => {
    window.$elmPorts.safeSend("flashFromJavascript", {
      level: "notification",
      title: "Document uploading",
      message: "This may take a few minutes.",
      time: Date.now(),
      indefinite: false,
      position: "bottom"
    });
  };
  this.notifyFailure = () => {
    window.$elmPorts.safeSend("flashFromJavascript", {
      level: "alert",
      title: null,
      message: "Document failed to upload, please try again.",
      time: Date.now(),
      indefinite: false,
      position: "bottom"
    });
  };
  this.notifySuccess = (fileCount) => {
    const maybePlural = fileCount > 1 ? "s" : "";
    const message = `${fileCount} Document${maybePlural} uploaded.`;
    window.$elmPorts.safeSend("flashFromJavascript", {
      level: "success",
      title: "Success",
      message,
      time: Date.now(),
      indefinite: false,
      position: "bottom"
    });
  };
};
const addDocumentToLoadUpdateHandlerService = new AddDocumentToLoadUpdateHandlerService();
export default addDocumentToLoadUpdateHandlerService;
